import { render, staticRenderFns } from "./AccessWalletPrivateKey.vue?vue&type=template&id=b4212a0c&"
import script from "./AccessWalletPrivateKey.vue?vue&type=script&lang=js&"
export * from "./AccessWalletPrivateKey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports